<div class="scrollby-menu">
  <ul>
    @for(menuItem of menuItems; track $index){
    <li [class.active]="menuItem === activeMenuItem" (click)="scrollTo(menuItem)">
      {{ menuItem }}
    </li>
    }
  </ul>
</div>